import { get } from 'lodash';

const root = state => get(state, 'UtilitiesState.assignEntities');

export const getAllSitesData = state => get(root(state), 'allSitesData', []);
export const getLoadingAllSites = state =>
  get(root(state), 'loadingAllSites', false);
export const getAllSitesLoadingError = state =>
  get(root(state), 'allSitesLoadingError', null);
export const getIsSubmitting = state => get(root(state), 'isSubmitting', false);
export const getSubmitted = state => get(root(state), 'submitted', false);
export const getSubmitError = state => get(root(state), 'submitError', null);
export const getSiteGroupData = state => get(root(state), 'siteGroupData', []);
export const getLoadingSiteGroup = state =>
  get(root(state), 'loadingSiteGroup', false);
export const getSiteGroupLoadingError = state =>
  get(root(state), 'siteGroupLoadingError', null);
export const getAllItemsData = state => get(root(state), 'allItemsData', []);
export const getLoadingAllItems = state =>
  get(root(state), 'loadingAllItems', false);
export const getAllItemsLoadingError = state =>
  get(root(state), 'allItemsLoadingError', null);
export const getLoadingAllUsers = state =>
  get(root(state), 'loadingAllUsers', false);
export const getAllUsersLoadingError = state =>
  get(root(state), 'allUsersLoadingError', null);
export const getAllUsersData = state => get(root(state), 'allUsersData', []);
export const getStorageLocationByIdLoadingError = state =>
  get(root(state), 'storageLocationByIdLoadingError', null);
export const getSitesByItemId = state => get(root(state), 'sitesByItemId', []);
export const getItemsBySiteId = state => get(root(state), 'itemsBySiteId', []);
export const getSiteGroupsByItemId = state =>
  get(root(state), 'siteGroupsByItemId', []);
export const getItemsBySiteGroupId = state =>
  get(root(state), 'itemsBySiteGroupId', []);
export const getSitesByUserName = state =>
  get(root(state), 'sitesByUserName', []);
export const getSiteGroupsByUserName = state =>
  get(root(state), 'siteGroupsByUserName', []);
export const getUsersBySiteGroupId = state =>
  get(root(state), 'usersBySiteGroupId', []);
export const getUsersBySiteId = state => get(root(state), 'usersBySiteId', []);
export const getAssignedStorageLocationData = state =>
  get(root(state), 'assignedStorageLocationData', null);
export const getSubmitSuccessMsg = state =>
  get(root(state), 'submitSuccessMsg', '');
export const getLoadingStorageLocationById = state =>
  get(root(state), 'loadingStorageLocationById', false);



// WEBPACK FOOTER //
// ./src/pages/utilities/state/assignEntities/selectors.js